import { useCallback } from 'react';
import { ImmerFuncs } from '../../../../external/immer/immer.funcs';
import { NodeWire } from '../../../../external/server/node.wire';
import { ServerApi } from '../../../../external/server/server.api';
import { MegaBoardContentWire, MegaBoardItemWire } from '../../../core/board/mega/mega-board-content.wire';
import { MegaBoardContentWireFuncs } from '../../../core/board/mega/mega-board-content.wire.funcs';
import { NodeStore } from '../../../core/node/node.store';
import { AppStore } from '../../app/app.store';
import { NodeItem } from '../../node/node-item';
import { MegaBoardItemStyle } from './mega-board-item.style';

export function MegaBoardItem({
  rowId,
  colId,
  item,
  hasPrev,
  hasNext,
}: {
  rowId: string;
  colId: string;
  hasPrev?: boolean;
  hasNext?: boolean;
  item?: MegaBoardItemWire;
}) {
  const didCreate = useCallback((createdNode: NodeWire) => {
    const currentBoardId = AppStore.get().currentBoardId!;
    let board = NodeStore.getItem(currentBoardId);
    const sub = ImmerFuncs.produce(board.sub as MegaBoardContentWire, (draft) => {
      MegaBoardContentWireFuncs.addItem(draft, { rowId, colId, item: { id: createdNode.id } });
    });
    NodeStore.updateItem(currentBoardId, { sub });
    ServerApi.updateNode(currentBoardId, { sub });
  }, []);

  const handleRemove = useCallback((nodeId: string) => {
    const currentBoardId = AppStore.get().currentBoardId!;
    let board = NodeStore.getItem(currentBoardId);
    const sub = ImmerFuncs.produce(board.sub as MegaBoardContentWire, (draft) => {
      MegaBoardContentWireFuncs.removeItem(draft, { rowId, colId, itemId: nodeId });
    });
    NodeStore.updateItem(currentBoardId, { sub });
    ServerApi.updateNode(currentBoardId, { sub });
  }, []);

  return (
    <MegaBoardItemStyle.Container>
      <NodeItem nodeId={item?.id} didCreate={didCreate} onRemove={handleRemove} />
    </MegaBoardItemStyle.Container>
  );
}
